const Legend=()=>{
  return (
  <div className="card border-secondary mb-3">
  <div className="card-header" style={{'background': '#343a40', 'color': '#fff', 'textAlign': 'center', 'fontSize': '1.2rem', 'fontWeight': '400'}}>Legend</div>
  <div className="card-body">
    <div className='my-legend'>
      <div className='legend-title'>Permission Group Colours</div>
      <div className='legend-scale'>
        <ul className='legend-labels'>
          <li><span style={{ 'background': '#19b341' }}>Match</span>- The group is present both on Role and Employee. No actions are needed.</li>
          <li><span style={{ 'background': '#FFA500' }}>Add</span>- The group is present on the Role only. It needs to be assigned to the employee.</li>
          <li><span style={{ 'background': '#ff6666' }}>Remove</span>- The group is present on the Employee only. The group has to be removed.</li>
          <li><span style={{ 'background': '#C0C0C0' }}>Inactive</span>- The group is assigned to an Inactive Account.</li>
        </ul>
      </div>
    </div>
  </div>
</div>);
}

export default Legend;